import { useStyles } from "@webapps/styles";
import { Button, Checkbox } from "@material-ui/core";
import { useCalendar } from "pages/school/ClassesPage/ClassesDetail/Stores/CalendarProvider";
import Planning from "components/Icons/Planning";
import { AlarmRounded, GetApp, Replay } from "@material-ui/icons";
import { useRef } from "react";
import { planningColorsText } from "pages/school/ClassesPage/Classes/colors/planningColors";

function PlanningManagerRight({ isDownloadingPlanning, setIsDownloadingPlanning, setOpenDeletePeriods, handleGeneratePDFWithNode }) {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { state, dispatch } = useCalendar(); // Récupération du contexte



  const handleVisibleCategory = (category) => {
    dispatch({ type: "TOGGLE_CATEGORY_VISIBILITY", payload: category });
  };

  return (
    <div className={classes.container}>
      <div className={classes.categoryContainer}>
        <div className={cx(classes.categoryContainerTitle, global.title)}>
          Activités
        </div>
        <div className={classes.mapContainer}>
          {
            Object.entries(state.categoryTotals).map(([key, value]) => {
              return (
                <div key={key} className={classes.category}
                  onClick={() => handleVisibleCategory(key)}
                >
                  <div className={classes.duoInputTitle}>
                    <Checkbox
                      className={css({
                        padding: '0px',
                        '.MuiIconButton-label': { color: planningColorsText[key] },
                      })}
                      checked={state.categoryTotals[key].visible}
                      name="jobAdvantages"
                      disableTouchRipple={true}
                      disableRipple={true}
                    />
                    <div className={cx(classes.categoryTitle, global.titleMediaQuery)}>{key === "FERIES" ? "Jours fériés" : key === "VACANCES" ? "Vacances" : `En ${key.toLocaleLowerCase()}`}</div>
                  </div>
                  <div className={cx(classes.categoryTotal, global.subTitleMediaQuery)}>{`${value.days}j - ${value.hours}h`}</div>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

const styles = () => ({
  container: {
    position: 'sticky',
    // width: "40%",
    zIndex: 1000,
    "@media (max-width: 1110px)": {
      display: 'none'
    },
    '.Mui-checked:hover': { backgroundColor: "unset!important" },
    '.MuiIconButton-colorSecondary:hover': { backgroundColor: "unset!important" },
  },
  infoSelectionContainer: {
    backgroundColor: 'white',
    borderRadius: '22px',
    padding: '10px',
    marginBottom: '20px',
  },
  infoSelectionSubContainer: {
    alignItems: 'center',
    backgroundColor: '#C0D9FF',
    borderRadius: '12px',
    display: 'flex',
    flex: 'none',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    gap: '20px',
    padding: '20px',
    textAlign: 'center',
  },
  textInfoContainer: {
    width: "250px"
  },
  img: {
    width: "120px",
    height: "60px",
  },
  subTitle: {
    marginTop: '10px',
    fontSize: "12px",
    color: "#152652",
    maxWidth: "250px"
  },
  boldSpan: {
    fontWeight: "bold",
  },
  infoText: {
    fontSize: "13.5px",
    color: "#0060F9",
    fontFamily: "Montserrat",
    fontWeight: "500",
  },
  infoButtonText: {
    fontSize: "13.5px",
    // color: "#0060F9",
    fontFamily: "Montserrat",
    fontWeight: "500",
    whiteSpace: "nowrap",

  },
  inputContainer: {
    display: 'flex',
    gap: '10px',
  },
  input: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: "white",
    color: "#0060F9",
    padding: '8px',
    width: "auto",
    borderRadius: "400px"
  },
  toggleSwitch: {
    position: 'relative',
    display: 'inline-block',
    width: '50px',
    height: '24px',
  },
  input2: {
    opacity: "0",
    width: "0",
    height: "0",

    "&:checked + .slider": {
      backgroundColor: '#0060F9',
    },

    "&:checked + .slider:before": {
      transform: 'translateX(26px)',
      backgroundColor: "white"
    },
  },
  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#75A8FB',
    transition: '0.4s',
    borderRadius: '24px',

    "&:before": {
      position: 'absolute',
      content: '""',
      height: '18px',
      width: '18px',
      left: '3px',
      bottom: '3px',
      backgroundColor: '#0060F9',
      transition: '0.4s',
      borderRadius: '50%',
    },
  },
  categoryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '20px',
    borderRadius: '22px',
    backgroundColor: "white",
    fontFamily: "Montserrat",
  },
  mapContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  category: {
    fontFamily: "Montserrat",
    padding: '10px',
    borderRadius: '10px',
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    // backgroundColor: "white",
    padding: "0px",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
    "&:hover": {
      // scale: "0.9"
    },
  },
  duoInputTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  categoryTitle: {
    // fontSize: "15px",
    fontWeight: "500",
    color: "#152652",
    // marginRight: "7px"
  },
  categoryTotal: {
    // fontSize: "15px",
    fontWeight: "400",
    color: "#152652",
    fontStyle: "italic"
  },
  hoursInputContainer: {
    padding: "5px 15px",
    color: "#92ABD2",
    border: "1px solid transparent",
    "&:hover": {
      border: "1px solid #0060F9",
      color: "#0060F9",
    },
  },
  hoursText: {
    height: "20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  hoursInputTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "20px",
    cursor: "pointer",
    color: "#92ABD2",
  },
  hoursInput: {
    border: "none",
    background: "transparent",
    // fontSize: "1em",
    fontFamily: "inherit",
    width: "13.5px",
    textAlign: "right",
    outline: "none",
    color: "#92ABD2",
    fontWeight: "500",
    // Enlève les flèches Chrome/Safari/Edge
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    // Enlève les flèches sur Firefox
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
  },

  minutesFake: {
    // fontSize: "1em",
    color: "#92ABD2",
    marginLeft: "2px",
    marginRight: "8px",
    fontFamily: "inherit",
    fontWeight: "500",
    userSelect: "none",
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    // justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  exportButton: {
    backgroundColor: "#F3F7FF",
    color: "#5D75A8",
    border: "1px solid #C0D9FF",
    fontWeight: 400,
    whiteSpace: "nowrap",
    '&:hover': {
      backgroundColor: "#F3F7FF",
      border: "1px solid #0060F9",
      color: "#0060F9",
    },
    width: '50%',

  },
  deleteButton: {
    backgroundColor: "#F50057",
    color: "white",
    borderRadius: "400px",
    whiteSpace: "nowrap",

    "&:hover": {
      backgroundColor: "#C51162",
      color: "white",
    },
    width: '50%',
  },
});

export default PlanningManagerRight;